// src/features/owner/sections/content/ContentModerationSection.tsx — read-only oversight (no override).
import { useOwnerModeration } from '@/hooks';
import { MetaRow } from '@/ui';
import { OwnerPanel, EmptyState } from '../../components';

export function ContentModerationSection() {
  const { data, loading, error } = useOwnerModeration();

  if (loading) return <p style={{ opacity: 0.6 }}>Loading…</p>;
  if (error || !data) return <EmptyState icon="shield" message={error ?? 'No data'} />;

  return (
    <>
      <OwnerPanel title="Cases by status">
        {Object.entries(data.byStatus).length === 0 ? (
          <EmptyState icon="shield" message="No cases" />
        ) : (
          Object.entries(data.byStatus).map(([s, n]) => (
            <div
              key={s}
              style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0' }}
            >
              <span>{s}</span>
              <b>{n}</b>
            </div>
          ))
        )}
      </OwnerPanel>
      <div style={{ height: 10 }} />
      <OwnerPanel title="Open cases (oversight only: decisions stay with the Council)">
        {data.queue.length === 0 ? (
          <EmptyState icon="shield" message="No open cases" />
        ) : (
          data.queue.map((c) => (
            <div
              key={c.id}
              style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0' }}
            >
              <MetaRow>
                {c.id}
                {c.kind}
              </MetaRow>
              <b>{c.category}</b>
            </div>
          ))
        )}
      </OwnerPanel>
    </>
  );
}
